// Zdania ostrzeżeń przy zestawie (26.10.2026): kiedy zestaw nigdy albo tylko czasem nie zadziała.
// Dane liczy serwer (Login/backend/lib/bundleCheck.js, GET /api/bundle-check i lista zestawów),
// tu powstaje wyłącznie tekst. Zestaw droższy od sztuk liczonych osobno po prostu się nie stosuje
// (zestaw nigdy nie podnosi ceny), więc bez ostrzeżenia firma nie wiedziałaby, że nie działa.

const ZLOTE = new Intl.NumberFormat('pl-PL', { style: 'currency', currency: 'PLN' });
export const formatZl = (n) => ZLOTE.format(Number(n) || 0);

const widelki = (min, max) => (Number(min) === Number(max) ? formatZl(min) : `${formatZl(min)}–${formatZl(max)}`);

/** Nazwa składnika: „Narty · Premium” albo sama kategoria, gdy klasa dowolna. */
export function nazwaSkladnika(item, { typeById = {}, classById = {} } = {}) {
  const typ = typeById[item.type_id] || `#${item.type_id}`;
  if (item.class_id == null) return typ;
  return `${typ} · ${classById[item.class_id] || `#${item.class_id}`}`;
}

/** Tekst jednego ostrzeżenia. `t` z useTranslation. */
export function trescOstrzezenia(w, { t, typeById, classById }) {
  const zakres = t(w.scope === 'classes' ? 'bundleWarn.scopeClasses' : 'bundleWarn.scopeEquipment');
  if (w.code === 'missing') {
    const items = (w.missing || []).map((i) => nazwaSkladnika(i, { typeById, classById })).join(', ');
    return t(w.scope === 'classes' ? 'bundleWarn.missingClasses' : 'bundleWarn.missingEquipment', { scope: zakres, items });
  }
  const p = { scope: zakres, range: widelki(w.min, w.max), bundle: formatZl(w.bundle) };
  // Klucze wprost (audyt tłumaczeń widzi tylko stałe klucze).
  if (w.code === 'never') return w.period === 'long' ? t('bundleWarn.neverLong', p) : t('bundleWarn.neverShort', p);
  return w.period === 'long' ? t('bundleWarn.sometimesLong', p) : t('bundleWarn.sometimesShort', p);
}

/** Najpoważniejsze ostrzeżenie na liście zestawów: „nigdy” i brak przed „czasem”. */
export function najwazniejsze(warnings) {
  const lista = Array.isArray(warnings) ? warnings : [];
  return lista.find((w) => w.code === 'never' || w.code === 'missing') || lista[0] || null;
}

/** Parametr `items` dla GET /api/bundle-check: „typ:klasa,…”, klasa 0 = dowolna. */
export const parametrSkladnikow = (typeIds, classByType = {}) => typeIds
  .map((typeId) => `${typeId}:${classByType[typeId] ? Number(classByType[typeId]) : 0}`)
  .join(',');

/**
 * Znacznik przy nazwie zestawu na liście: 'never' (nie zadziała w żadnym przypadku: w każdym
 * zakresie, którego dotyczą ostrzeżenia, brakuje sprzętu albo nie działa ani do 7 dni, ani dłużej),
 * 'partly' (w części przypadków nigdy), 'sometimes' (tylko dla droższych sztuk), null bez ostrzeżeń.
 */
export function rodzajZnacznika(warnings) {
  const lista = Array.isArray(warnings) ? warnings : [];
  if (!lista.length) return null;
  const zakresy = [...new Set(lista.map((w) => w.scope))];
  const nigdyWZakresie = (s) => lista.some((w) => w.scope === s && w.code === 'missing')
    || ['short', 'long'].every((p) => lista.some((w) => w.scope === s && w.code === 'never' && w.period === p));
  if (zakresy.every(nigdyWZakresie)) return 'never';
  if (lista.some((w) => w.code === 'never' || w.code === 'missing')) return 'partly';
  return 'sometimes';
}

/**
 * Ostrzeżenia złączone po zakresie (sprzęt, klasy): gdy oba okresy (do 7 dni i dłużej) mają ten
 * sam rodzaj, powstaje JEDNO zdanie z obiema cenami zamiast dwóch prawie identycznych.
 * Zwraca listę w kolejności zakresów: { scope, code, period, short, long, missing }.
 */
export function polaczOstrzezenia(warnings) {
  const lista = Array.isArray(warnings) ? warnings : [];
  const wynik = [];
  for (const scope of [...new Set(lista.map((w) => w.scope))]) {
    const zakres = lista.filter((w) => w.scope === scope);
    const brak = zakres.find((w) => w.code === 'missing');
    if (brak) { wynik.push(brak); continue; }
    const krotki = zakres.find((w) => w.period === 'short');
    const dlugi = zakres.find((w) => w.period === 'long');
    if (krotki && dlugi && krotki.code === dlugi.code) {
      wynik.push({ scope, code: krotki.code, period: 'both', short: krotki, long: dlugi });
    } else {
      wynik.push(...zakres);
    }
  }
  return wynik;
}

/** Tekst ostrzeżenia złączonego (period 'both') albo pojedynczego, jak trescOstrzezenia. */
export function trescPolaczona(w, { t, typeById, classById }) {
  if (w.period !== 'both') return trescOstrzezenia(w, { t, typeById, classById });
  const zakres = t(w.scope === 'classes' ? 'bundleWarn.scopeClasses' : 'bundleWarn.scopeEquipment');
  const cenaZestawu = Number(w.short.bundle) === Number(w.long.bundle)
    ? formatZl(w.short.bundle)
    : t('bundleWarn.bundleWithOver7', { price: formatZl(w.short.bundle), over7: formatZl(w.long.bundle) });
  const p = {
    scope: zakres,
    range: widelki(w.short.min, w.short.max),
    rangeLong: widelki(w.long.min, w.long.max),
    bundle: cenaZestawu,
  };
  return w.code === 'never' ? t('bundleWarn.neverBoth', p) : t('bundleWarn.sometimesBoth', p);
}
